// Parent layout for /networks/$id/admin/*. Auth gate + Outlet; children
// share the gate without re-implementing it.

import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { requireLeaderOrAdmin } from '@/lib/route-guards';

export const Route = createFileRoute('/_authed/networks/$id/admin')({
  beforeLoad: async ({ context, params }) => {
    await requireLeaderOrAdmin(context, {
      groupId: params.id,
      bounceTo: () =>
        redirect({ to: '/networks/$id', params: { id: params.id } }),
    });
  },
  component: Outlet,
});
